import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { AuthService } from 'src/app/services/auth.service';
import { SsoService } from '@services/sso.service';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {

  public error: any;
  public loginForm: FormGroup;
  public isLegacyLogin: boolean = false;
  public isLoading: boolean = false;
  public environment = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private ssoService: SsoService,
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['',
        Validators.compose([Validators.required, Validators.email])
      ],
      password: ['',
        Validators.compose([])
      ]
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.loginForm.get('username')?.setValue(decodeURIComponent(params['email']));
      }
    });
  }

  public precheckLogin(): void {
    this.isLoading = true;
    this.error = null;

    this.authService.precheckLogin(this.loginForm.value.username).then((requiresSso: boolean) => {
      if (requiresSso) {
        this.redirectToLogin();
      } else {
        this.isLoading = false;
        this.isLegacyLogin = true;
        this.loginForm.get('password')?.setValidators([Validators.required]);
      }
    }).catch((error: any) => {
      this.isLoading = false;

      this.error = error || 'Die Anmeldung ist momentan nicht möglich.';
    });
  }

  public loginUser(): void {
    this.isLoading = true;
    this.error = null;

    this.authService.loginUser(this.loginForm.value.username, this.loginForm.value.password).then(() => {
      if (this.authService.redirectUrl) {
        this.router.navigateByUrl(this.authService.redirectUrl);
        this.authService.redirectUrl = '';
      } else {
        this.router.navigateByUrl('/app');
      }
      this.isLoading = false;
    }).catch((error: any) => {
      this.isLoading = false;

      this.error = error || 'Die Anmeldung ist momentan nicht möglich.';
    });
  }

  public redirectToLogin() {
    this.ssoService.redirectToLogin();
  }

}
